import React from 'react';

interface ShareToggleProps {
  isPublic: boolean;
  isToggling: boolean;
  onToggle: () => void;
  size?: 'sm' | 'md';
}

export const ShareToggle: React.FC<ShareToggleProps> = ({
  isPublic,
  isToggling,
  onToggle,
  size = 'md'
}) => {
  const sizes = {
    sm: { track: 'w-10 h-[22px]', knob: 'w-[18px] h-[18px]', onPos: 'left-5', offPos: 'left-0.5' },
    md: { track: 'w-[52px] h-8', knob: 'w-[26px] h-[26px]', onPos: 'left-[23px]', offPos: 'left-[3px]' }
  };

  const s = sizes[size];

  return (
    <div className="flex items-center justify-between">
      <div>
        <p className={`font-semibold text-neutral-900 ${size === 'sm' ? 'text-[13px]' : 'text-[15px]'}`}>
          {isPublic ? 'Public' : 'Private'}
        </p>
        <p className={`text-neutral-500 ${size === 'sm' ? 'text-[11px]' : 'text-[13px] mt-0.5'}`}>
          {isPublic ? 'Anyone with link can view' : 'Only you can access'}
        </p>
      </div>
      <button
        type="button"
        onClick={onToggle}
        className={`relative ${s.track} rounded-full border-none cursor-pointer transition-colors duration-250 ${
          isPublic ? 'bg-neutral-900' : 'bg-neutral-300'
        }`}
        aria-pressed={isPublic}
        aria-label={isPublic ? 'Disable public access' : 'Enable public access'}
      >
        <span
          className={`absolute top-0.5 ${s.knob} rounded-full bg-white shadow transition-all duration-250 ${
            isPublic ? s.onPos : s.offPos
          } ${isToggling ? 'animate-pulse' : ''}`}
        />
      </button>
    </div>
  );
};
